<template>
  <div class="p-3 position-relative d-flex flex-column" style="max-height: 100%">
    <legend class="w-100 d-flex flex-row justify-content-between">{{ titles[title] }}
      <button type="button" class="btn btn-sm btn-info toggle-margin-btn" id="btn-copy-table"
              data-clipboard-target="#order-table-list1">Копировать таблицу
      </button>
    </legend>
    <div class="d-flex flex-column overflow-auto">
      <table id="order-table-list1" class="table table-sm table-hover table-bordered">
        <thead>
        <tr>
          <th>Номер</th>
          <th>Клиентский номер</th>
          <th>Пункт</th>
          <th>Наименование</th>
          <th>Статус</th>
          <th>Оплачено</th>
          <th>Получено</th>
          <th>Дата отправки</th>
          <th>Дата доставки</th>
          <th>Курьер</th>
          <th>Цена</th>
          <th v-for="pt in stats.paymentTypes">{{ pt.Name }}</th>
          <th>Долг</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in stats.orders">
          <td>
            <router-link class="text-decoration-none text-dark"
                         target="_blank"
                         :to="{ name: 'order-info', params: {orderId: order.Id}}">
              {{ order.SferaNumber }}
            </router-link>
          </td>
          <td>{{ order.LocalNumber }}</td>
          <td>{{ order.Reception }}</td>
          <td>{{ order.Name }}</td>
          <td class="text-nowrap">{{ order.Status.Name }}</td>
          <td class="text-nowrap">{{ order.PaidDate }}</td>
          <td class="text-nowrap">{{ order.PassedDate }}</td>
          <td class="text-nowrap">{{ order.DispatchDate }}</td>
          <td class="text-nowrap">{{ order.DeliveryDate }}</td>
          <td>{{ order.Courier ? (order.Courier.Fname ? order.Courier.Fname : '') + ' ' + (order.Courier.Lname ? order.Courier.Lname : '') : '' }}</td>
          <td>{{ order.Summary }}</td>
          <td v-for="pt in stats.paymentTypes">
            <span v-if="order.PaymentType.Id === pt.Id">{{ order.Summary }}</span>
          </td>
          <td>{{ !order.PaidDate ? order.Summary : '' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { get } from '@/admin/services/api/http-utils';
import ClipboardJS from 'clipboard';

const queryString = require('query-string');

export default {
  props: {
    title: String,
    day: String,
    ccId: Number,
    ptId: Number,
  },
  data() {
    return {
      stats: [],
      titles: {
        notInDelivery: 'Не доставлено',
        delivered: 'Доставлено',
        paid: 'Оплачено',
        debtPaid: 'Оплачено долгов',
        debt: 'Долг (доставлено - не оплачено)',
        card: 'Оплата на карту',
      },
    };
  },
  async mounted() {
    switch (this.title) {
      case 'paid':
        await this.fetchStats_paid();
        break;
      case 'debtPaid':
        await this.fetchStats_debtPaid();
        break;
      case 'notInDelivery':
        await this.fetchStats_notInDelivery();
        break;
      case 'delivered':
        await this.fetchStats_delivered();
        break;
      case 'debtInDelivery':
        await this.fetchStats_debtInDelivery();
        break;
      case 'card':
        await this.fetchStats_getCardPaidOrders();
        break;
      default:
        alert('Ошибка');
    }

    const clipboard = new ClipboardJS('#btn-copy-table');
    clipboard.on('success', (e) => {
      e.clearSelection();
    });
  },
  methods: {
    async fetchStats_paid() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/orders-paid?${query}`);
      this.stats = data;
    },
    async fetchStats_debtPaid() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/orders-debt-paid?${query}`);
      this.stats = data;
    },
    async fetchStats_notInDelivery() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/orders-not-in-delivery?${query}`);
      this.stats = data;
    },
    async fetchStats_getCardPaidOrders() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/card-paid-orders?${query}`);
      this.stats = data;
    },

    async fetchStats_delivered() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/orders-delivered?${query}`);
      this.stats = data;
    },

    async fetchStats_debtInDelivery() {
      const query = queryString.stringify({
        day: this.day,
        ccId: this.ccId,
        ptId: this.ptId,
      });
      const { data } = await get(`/admin/stats/stats5/orders-debt-in-delivery?${query}`);
      this.stats = data;
    },
  },
};
</script>
